// extracted by mini-css-extract-plugin
export {};
    if(module.hot) {
      // 1756887905408
      var cssReload = require("/home/ansgar/Documents/Master/06_Internship/Website_root/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  